import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import {
    isEnabledForFrontierAudience,
    type FrontierFlightConfig,
} from './isEnabledForFrontierCopilotAudience';

const calendarCopilotSearchAnswerFrontierFlights: FrontierFlightConfig = {
    publicFlight: 'cal-copilotSearchAnswer-frontier-public',
    privateTapFlight: 'cal-copilotSearchAnswer-frontier-private-tap',
    privateStagingFlight: 'cal-copilotSearchAnswer-frontier-private-staging',
    privateInfluencerFlight: 'cal-copilotSearchAnswer-frontier-private-influencer',
};

export function isCalendarCopilotSearchAnswerEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        isGlobalFeatureEnabled('cal-copilotSearchAnswer') ||
        isEnabledForFrontierAudience(mailboxInfo, calendarCopilotSearchAnswerFrontierFlights)
    );
}
